<div id="carouselFOI" class="carousel slide carousel-fade" data-bs-ride="carousel" data-bs-interval="3000">

    <div class="carousel-indicators">
        <button type="button" data-bs-target="#carouselFOI"
            *ngFor="let item of data;let index = index; let isFirst = first" [attr.data-bs-slide-to]="index"
            [ngClass]="{active:isFirst}">
        </button>
    </div>
    
    <div class="carousel-inner">
        <div class="carousel-item" *ngFor="let t3d of data; let index = index; let isFirst = first"
            [ngClass]="{active:isFirst}">
            <img src="{{URL}}{{t3d.img}}" class="d-block w-100" alt="">
            <div class="carousel-caption">
                <div class="title-slider" [routerLink]="" target="_blank">
                    {{t3d.longtitle}}
                </div>
                <div class="field-of-interest" [routerLink]="" target="_blank">
                    {{t3d.eventtype}}
                </div>
            </div>
        </div>
    </div>
</div>